<div class="spinner-overlay" *ngIf="active">
  <div class="global-spinner-wrapper">
    <div class="spinner-wrapper">
      <div class="spinner">
        <img class="spin" src="/assets/icons/Deloitte-Spinner.svg" />
      </div>
      <div class="spinner-text">
        <label>{{'Translation.Spinnermsg' | translate}}</label>
      </div>
    </div>
  </div>
</div>
